module.exports = function() {
	return new Worker(__webpack_public_path__ + "116e818a0b3f56ad19e7.recommendations.wrkr.js");
};